import ExFactoryReferencePrice from './ExFactoryReferencePrice';
import PublicReferencePrice from './PublicReferencePrice';

export default class ReferencePrices {
	exFactory: ExFactoryReferencePrice[];

	public: PublicReferencePrice | null;

	constructor(exFactory: ExFactoryReferencePrice[], publicPrice: PublicReferencePrice | null) {
		this.exFactory = exFactory;
		this.public = publicPrice;
	}
}
